import React, { useRef } from 'react';
import TestimonialSection from '../../../components/common/TestimonialSlider/TestimonialSlider';
import useHorizontalScroll from '../../../hooks/useHorizontalScroll';
import SliderControls from '../../../components/common/SliderControls/SliderControls';
import { motion } from 'framer-motion';
import styles from './OurClients.module.scss'

const testimonials = [
  {
    quote: `The team delivered a robust Flutter-based application and admin ERP system that streamlined backend operations and data management across multiple outlets. Their understanding of scalability and enterprise requirements was impressive.`,
    name: 'Mc’ donal’s Starbucks',
    location: 'Pune, India',
  },
  {
    quote: `They developed a user-friendly platform that successfully connects multiple local businesses with customers. The booking flow and location-based service discovery work smoothly and reliably.`,
    name: 'profile baba',
    location: 'Delhi, India ',
  },
  {
    quote: `The solution provided for construction project management, including site mapping and offline/online workflows, significantly improved operational efficiency across international sites.`,
    name: 'Asite field',
    location: 'USA',
  },
  {
    quote: `The gym management application effectively combines training programs, user engagement, and product sales. The app performance and overall experience exceeded our expectations!`,
    name: 'Easy gym',
    location: 'Uk',
  },
  {
    quote: `A well-structured learning platform with ERP integration was delivered on time. The system supports both academic management and digital learning seamlessly!`,
    name: 'One vision',
    location: 'Pakistan',
  },
  {
    quote: `The project execution was professional and technically sound. The team demonstrated strong expertise in modern application development and reliable delivery!`,
    name: 'Pixel digital',
    location: 'Canada',
  },
  {
    quote: `The IoT-based solution developed for laboratory and research environments met our technical requirements precisely. Data accuracy, device integration, and system reliability were key strengths.`,
    name: 'Cambrian bio works',
    location: 'Bengaluru, India',
  },
  {
    quote: `The development team provided scalable and well-optimized solutions aligned with our business goals. Communication and technical execution were consistently strong.`,
    name: 'Teqexpert',
    location: 'Delhi, India',
  },
  {
    quote: `The solution provided supported smooth operations and data handling. The team demonstrated professionalism and a strong command of modern development practices.`,
    name: 'Spinny',
    location: 'Delhi, India',
  },
  {
    quote: `A reliable development experience with timely delivery and consistent technical support throughout the project lifecycle.`,
    name: 'Aquarious',
    location: 'Kolkata, India',
  },
  {
    quote: `The application was delivered with a strong focus on performance, security, and scalability. The team showed good domain understanding.`,
    name: 'Celloip',
    location: 'Ahemdabad, India',
  },
  {
    quote: `They provided a clean and well-structured solution tailored to our needs. Overall execution and responsiveness were excellent.`,
    name: 'Ultraneous',
    location: 'Ahemdabad, India',
  },


];
const sectionVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 1, ease: 'easeOut' },
  },
};

const headingStagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const headingText = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: 'easeOut' },
  },
};

const OurClients = () => {
  const sliderRef = useRef(null);

  const {
    showLeft,
    showRight,
    scrollToStart,
    scrollToEnd,
  } = useHorizontalScroll(sliderRef);

  return (
    <motion.section
      className={styles.ourClientSection}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={sectionVariants}
    >
      <motion.div className={styles.headingRow}>
        <motion.div className={styles.heading} variants={headingStagger}>
          <h2 variants={headingText}>
            Our Valued <span>Clients</span>
          </h2>
          <p variants={headingText}>
            Discover The Brand’s Voice For Our Best Web & App Services In Surat
          </p>
        </motion.div>

        <SliderControls
          showLeft={showLeft}
          showRight={showRight}
          onLeft={scrollToStart}
          onRight={scrollToEnd}
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.9, ease: 'easeOut', delay: 0.2 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <TestimonialSection
          heading="Our Valued Clients"
          subheading="Discover The Brand’s Voice For Our Best Digital Marketing Services In Ahmedabad"
          ref={sliderRef}
          testimonials={testimonials}
        />
      </motion.div>
    </motion.section>
  );
};

export default OurClients;








